import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {selectToken} from '@shared/store/auth/auth.selector';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private router: Router, private store: Store) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(selectToken).pipe(
      map((token) => {

        if (token) {
          return true; // User is logged in, allow route activation
        }

        // User not logged in, redirect to login with the intended URL as a query param
        this.router.navigate(['/auth/login'], { queryParams: { nextTo: state.url } });
        return false;
      })
    );
  }
}
